// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleOwner = {
  id: "owner",
  mrn: "//iam.api.mondoo.app/roles/owner",
  title: "Owner",
  allowedActions,
} as const;

export type RoleOwner = typeof roleOwner;
